import Cookies from 'js-cookie'

const TokenKey = 'Token'
const StoreKey= 'StoreKey'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function getStoreKey() {
  return Cookies.get(StoreKey)
}

export function setStoreKey(key) {
  return Cookies.set(StoreKey, key)
}

export function removeStoreKey() {
  return Cookies.remove(StoreKey)
}